import _possibleConstructorReturn from '../@babel/runtime/helpers/esm/possibleConstructorReturn.js';
import _getPrototypeOf from '../@babel/runtime/helpers/esm/getPrototypeOf.js';
import _inherits from '../@babel/runtime/helpers/esm/inherits.js';
import _toConsumableArray from '../@babel/runtime/helpers/esm/toConsumableArray.js';
import _slicedToArray from '../@babel/runtime/helpers/esm/slicedToArray.js';
import _classCallCheck from '../@babel/runtime/helpers/esm/classCallCheck.js';
import _createClass from '../@babel/runtime/helpers/esm/createClass.js';
import _typeof from '../@babel/runtime/helpers/esm/typeof.js';

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var t;
var i = window,
  s = i.trustedTypes,
  e = s ? s.createPolicy("lit-html", {
    createHTML: function createHTML(t) {
      return t;
    }
  }) : void 0,
  o = "$lit$",
  n = "lit$".concat((Math.random() + "").slice(9), "$"),
  l = "?" + n,
  h = "<".concat(l, ">"),
  r = document,
  u = function u() {
    return r.createComment("");
  },
  d = function d(t) {
    return null === t || "object" != _typeof(t) && "function" != typeof t;
  },
  c = Array.isArray,
  v = function v(t) {
    return c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]);
  },
  a = "[ \t\n\f\r]",
  f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,
  _ = /-->/g,
  m = />/g,
  p = RegExp(">|".concat(a, "(?:([^\\s\"'>=/]+)(").concat(a, "*=").concat(a, "*(?:[^ \t\n\f\r\"'`<>=]|(\"|')|))|$)"), "g"),
  g = /'/g,
  $ = /"/g,
  y = /^(?:script|style|textarea|title)$/i,
  w = function w(t) {
    return function (i) {
      for (var _len = arguments.length, s = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        s[_key - 1] = arguments[_key];
      }
      return {
        _$litType$: t,
        strings: i,
        values: s
      };
    };
  },
  x = w(1),
  b = w(2),
  T = Symbol.for("lit-noChange"),
  A = Symbol.for("lit-nothing"),
  E = new WeakMap(),
  C = r.createTreeWalker(r, 129, null, !1);
function P(t, i) {
  if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return void 0 !== e ? e.createHTML(i) : i;
}
var V = function V(t, i) {
  var s = t.length - 1,
    e = [];
  var l,
    r = 2 === i ? "<svg>" : "",
    u = f;
  for (var _i = 0; _i < s; _i++) {
    var _s = t[_i];
    var _d = void 0,
      _c = void 0,
      _v = -1,
      _a = 0;
    for (; _a < _s.length && (u.lastIndex = _a, _c = u.exec(_s), null !== _c);) _a = u.lastIndex, u === f ? "!--" === _c[1] ? u = _ : void 0 !== _c[1] ? u = m : void 0 !== _c[2] ? (y.test(_c[2]) && (l = RegExp("</" + _c[2], "g")), u = p) : void 0 !== _c[3] && (u = p) : u === p ? ">" === _c[0] ? (u = null != l ? l : f, _v = -1) : void 0 === _c[1] ? _v = -2 : (_v = u.lastIndex - _c[2].length, _d = _c[1], u = void 0 === _c[3] ? p : '"' === _c[3] ? $ : g) : u === $ || u === g ? u = p : u === _ || u === m ? u = f : (u = p, l = void 0);
    var _w = u === p && t[_i + 1].startsWith("/>") ? " " : "";
    r += u === f ? _s + h : _v >= 0 ? (e.push(_d), _s.slice(0, _v) + o + _s.slice(_v) + n + _w) : _s + n + (-2 === _v ? (e.push(void 0), _i) : _w);
  }
  return [P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")), e];
};
var N = /*#__PURE__*/function () {
  function N(_ref, e) {
    var t = _ref.strings,
      i = _ref._$litType$;
    _classCallCheck(this, N);
    var h;
    this.parts = [];
    var r = 0,
      d = 0;
    var c = t.length - 1,
      v = this.parts,
      _V = V(t, i),
      _V2 = _slicedToArray(_V, 2),
      a = _V2[0],
      f = _V2[1];
    if (this.el = N.createElement(a, e), C.currentNode = this.el.content, 2 === i) {
      var _t = this.el.content,
        _i2 = _t.firstChild;
      _i2.remove(), _t.append.apply(_t, _toConsumableArray(_i2.childNodes));
    }
    for (; null !== (h = C.nextNode()) && v.length < c;) {
      if (1 === h.nodeType) {
        if (h.hasAttributes()) {
          var _t2 = [];
          var _iterator = _createForOfIteratorHelper(h.getAttributeNames()),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _i5 = _step.value;
              if (_i5.endsWith(o) || _i5.startsWith(n)) {
                var _s2 = f[d++];
                if (_t2.push(_i5), void 0 !== _s2) {
                  var _t4 = h.getAttribute(_s2.toLowerCase() + o).split(n),
                    _i6 = /([.?@])?(.*)/.exec(_s2);
                  v.push({
                    type: 1,
                    index: r,
                    name: _i6[2],
                    strings: _t4,
                    ctor: "." === _i6[1] ? H : "?" === _i6[1] ? L : "@" === _i6[1] ? z : k
                  });
                } else v.push({
                  type: 6,
                  index: r
                });
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          for (var _i3 = 0, _t3 = _t2; _i3 < _t3.length; _i3++) {
            var _i4 = _t3[_i3];
            h.removeAttribute(_i4);
          }
        }
        if (y.test(h.tagName)) {
          var _t5 = h.textContent.split(n),
            _i7 = _t5.length - 1;
          if (_i7 > 0) {
            h.textContent = s ? s.emptyScript : "";
            for (var _s3 = 0; _s3 < _i7; _s3++) h.append(_t5[_s3], u()), C.nextNode(), v.push({
              type: 2,
              index: ++r
            });
            h.append(_t5[_i7], u());
          }
        }
      } else if (8 === h.nodeType) if (h.data === l) v.push({
        type: 2,
        index: r
      });else {
        var _t6 = -1;
        for (; -1 !== (_t6 = h.data.indexOf(n, _t6 + 1));) v.push({
          type: 7,
          index: r
        }), _t6 += n.length - 1;
      }
      r++;
    }
  }
  _createClass(N, null, [{
    key: "createElement",
    value: function createElement(t, i) {
      var s = r.createElement("template");
      return s.innerHTML = t, s;
    }
  }]);
  return N;
}();
function S(t, i) {
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t;
  var e = arguments.length > 3 ? arguments[3] : undefined;
  var o, n, l, h;
  if (i === T) return i;
  var r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
  var u = d(i) ? void 0 : i._$litDirective$;
  return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = S(t, r._$AS(t, i.values), r, e)), i;
}
var M = /*#__PURE__*/function () {
  function M(t, i) {
    _classCallCheck(this, M);
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
  }
  _createClass(M, [{
    key: "parentNode",
    get: function get() {
      return this._$AM.parentNode;
    }
  }, {
    key: "_$AU",
    get: function get() {
      return this._$AM._$AU;
    }
  }, {
    key: "u",
    value: function u(t) {
      var i;
      var _this$_$AD = this._$AD,
        s = _this$_$AD.el.content,
        e = _this$_$AD.parts,
        o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : r).importNode(s, !0);
      C.currentNode = o;
      var n = C.nextNode(),
        l = 0,
        h = 0,
        u = e[0];
      for (; void 0 !== u;) {
        if (l === u.index) {
          var _i8 = void 0;
          2 === u.type ? _i8 = new R(n, n.nextSibling, this, t) : 1 === u.type ? _i8 = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (_i8 = new Z(n, this, t)), this._$AV.push(_i8), u = e[++h];
        }
        l !== (null == u ? void 0 : u.index) && (n = C.nextNode(), l++);
      }
      return C.currentNode = r, o;
    }
  }, {
    key: "v",
    value: function v(t) {
      var i = 0;
      var _iterator2 = _createForOfIteratorHelper(this._$AV),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _s4 = _step2.value;
          void 0 !== _s4 && (void 0 !== _s4.strings ? (_s4._$AI(t, _s4, i), i += _s4.strings.length - 2) : _s4._$AI(t[i])), i++;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);
  return M;
}();
var R = /*#__PURE__*/function () {
  function R(t, i, s, e) {
    _classCallCheck(this, R);
    var o;
    this.type = 2, this._$AH = A, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
  }
  _createClass(R, [{
    key: "_$AU",
    get: function get() {
      var t, i;
      return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
  }, {
    key: "parentNode",
    get: function get() {
      var t = this._$AA.parentNode;
      var i = this._$AM;
      return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
  }, {
    key: "startNode",
    get: function get() {
      return this._$AA;
    }
  }, {
    key: "endNode",
    get: function get() {
      return this._$AB;
    }
  }, {
    key: "_$AI",
    value: function _$AI(t) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      t = S(this, t, i), d(t) ? t === A || null == t || "" === t ? (this._$AH !== A && this._$AR(), this._$AH = A) : t !== this._$AH && t !== T && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : v(t) ? this.T(t) : this._(t);
    }
  }, {
    key: "k",
    value: function k(t) {
      return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
  }, {
    key: "$",
    value: function $(t) {
      this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
  }, {
    key: "_",
    value: function _(t) {
      this._$AH !== A && d(this._$AH) ? this._$AA.nextSibling.data = t : this.$(r.createTextNode(t)), this._$AH = t;
    }
  }, {
    key: "g",
    value: function g(t) {
      var i;
      var s = t.values,
        e = t._$litType$,
        o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = N.createElement(P(e.h, e.h[0]), this.options)), e);
      if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);else {
        var _t7 = new M(o, this),
          _i9 = _t7.u(this.options);
        _t7.v(s), this.$(_i9), this._$AH = _t7;
      }
    }
  }, {
    key: "_$AC",
    value: function _$AC(t) {
      var i = E.get(t.strings);
      return void 0 === i && E.set(t.strings, i = new N(t)), i;
    }
  }, {
    key: "T",
    value: function T(t) {
      c(this._$AH) || (this._$AH = [], this._$AR());
      var i = this._$AH;
      var s,
        e = 0;
      var _iterator3 = _createForOfIteratorHelper(t),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _o = _step3.value;
          e === i.length ? i.push(s = new R(this.k(u()), this.k(u()), this, this.options)) : s = i[e], s._$AI(_o), e++;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
  }, {
    key: "_$AR",
    value: function _$AR() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._$AA.nextSibling;
      var i = arguments.length > 1 ? arguments[1] : undefined;
      var s;
      for (null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;) {
        var _i10 = t.nextSibling;
        t.remove(), t = _i10;
      }
    }
  }, {
    key: "setConnected",
    value: function setConnected(t) {
      var i;
      void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
  }]);
  return R;
}();
var k = /*#__PURE__*/function () {
  function k(t, i, s, e, o) {
    _classCallCheck(this, k);
    this.type = 1, this._$AH = A, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String()), this.strings = s) : this._$AH = A;
  }
  _createClass(k, [{
    key: "tagName",
    get: function get() {
      return this.element.tagName;
    }
  }, {
    key: "_$AU",
    get: function get() {
      return this._$AM._$AU;
    }
  }, {
    key: "_$AI",
    value: function _$AI(t) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      var s = arguments.length > 2 ? arguments[2] : undefined;
      var e = arguments.length > 3 ? arguments[3] : undefined;
      var o = this.strings;
      var n = !1;
      if (void 0 === o) t = S(this, t, i, 0), n = !d(t) || t !== this._$AH && t !== T, n && (this._$AH = t);else {
        var _e = t;
        var _l, _h;
        for (t = o[0], _l = 0; _l < o.length - 1; _l++) _h = S(this, _e[s + _l], i, _l), _h === T && (_h = this._$AH[_l]), n || (n = !d(_h) || _h !== this._$AH[_l]), _h === A ? t = A : t !== A && (t += (null != _h ? _h : "") + o[_l + 1]), this._$AH[_l] = _h;
      }
      n && !e && this.j(t);
    }
  }, {
    key: "j",
    value: function j(t) {
      t === A ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
  }]);
  return k;
}();
var H = /*#__PURE__*/function (_k) {
  _inherits(H, _k);
  function H() {
    var _this;
    _classCallCheck(this, H);
    _this = _callSuper(this, H, arguments), _this.type = 3;
    return _this;
  }
  _createClass(H, [{
    key: "j",
    value: function j(t) {
      this.element[this.name] = t === A ? void 0 : t;
    }
  }]);
  return H;
}(k);
var I = s ? s.emptyScript : "";
var L = /*#__PURE__*/function (_k2) {
  _inherits(L, _k2);
  function L() {
    var _this2;
    _classCallCheck(this, L);
    _this2 = _callSuper(this, L, arguments), _this2.type = 4;
    return _this2;
  }
  _createClass(L, [{
    key: "j",
    value: function j(t) {
      t && t !== A ? this.element.setAttribute(this.name, I) : this.element.removeAttribute(this.name);
    }
  }]);
  return L;
}(k);
var z = /*#__PURE__*/function (_k3) {
  _inherits(z, _k3);
  function z(t, i, s, e, o) {
    var _this3;
    _classCallCheck(this, z);
    _this3 = _callSuper(this, z, [t, i, s, e, o]), _this3.type = 5;
    return _this3;
  }
  _createClass(z, [{
    key: "_$AI",
    value: function _$AI(t) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      var s;
      if ((t = null !== (s = S(this, t, i, 0)) && void 0 !== s ? s : A) === T) return;
      var e = this._$AH,
        o = t === A && e !== A || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive,
        n = t !== A && (e === A || o);
      o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(t) {
      var i, s;
      "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
  }]);
  return z;
}(k);
var Z = /*#__PURE__*/function () {
  function Z(t, i, s) {
    _classCallCheck(this, Z);
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
  }
  _createClass(Z, [{
    key: "_$AU",
    get: function get() {
      return this._$AM._$AU;
    }
  }, {
    key: "_$AI",
    value: function _$AI(t) {
      S(this, t);
    }
  }]);
  return Z;
}();
var B = i.litHtmlPolyfillSupport;
null == B || B(N, R), (null !== (t = i.litHtmlVersions) && void 0 !== t ? t : i.litHtmlVersions = []).push("2.8.0");
var D = function D(t, i, s) {
  var e, o;
  var n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
  var l = n._$litPart$;
  if (void 0 === l) {
    var _t8 = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
    n._$litPart$ = l = new R(i.insertBefore(u(), _t8), _t8, void 0, null != s ? s : {});
  }
  return l._$AI(t), l;
};

export { x as html, T as noChange, A as nothing, D as render, b as svg };
